import { useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { Navbar } from "../components/landing/Navbar";
import { Footer } from "../components/landing/Sections";
import { siteConfig } from "../data/mock";
import "../App.css";

const cards = [
  {
    title: "Discovery becomes structured intake",
    description:
      "The agent turns calls, docs, and customer notes into ServiceNow-ready process maps before configuration starts.",
  },
  {
    title: "Configuration work gets repeatable",
    description:
      "Common ITSM workflows, roles, approval paths, and integration requirements become reusable deployment steps.",
  },
  {
    title: "Validation is planned from day one",
    description:
      "ATF, UAT, and cutover checks are generated alongside the rollout plan so teams do not discover gaps at go-live.",
  },
];

export default function ServiceNowPage() {
  useEffect(() => {
    document.title = "Lab0 | ServiceNow deployments";
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <div className="min-h-screen bg-[#fafaf9] text-[#1a1a1a]">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />

      <main>
        <section className="servicenow-hero">
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <div className="absolute top-0 left-1/4 w-px h-full bg-black/[0.04]" />
            <div className="absolute top-0 left-2/4 w-px h-full bg-black/[0.04]" />
            <div className="absolute top-0 left-3/4 w-px h-full bg-black/[0.04]" />
            <div className="absolute top-1/4 left-0 w-full h-px bg-black/[0.04]" />
            <div className="absolute top-2/4 left-0 w-full h-px bg-black/[0.04]" />
            <div className="absolute top-3/4 left-0 w-full h-px bg-black/[0.04]" />
          </div>

          <div className="servicenow-hero-inner">
            <div className="servicenow-hero-copy">
              <h1>
                <span>lab0 implements</span>
                <span>servicenow</span>
              </h1>
              <p>
                Lab0 gives ServiceNow partners and internal platform teams an implementation agent that keeps discovery, configuration, validation, and blocker tracking in one deployment loop.
              </p>
              <a
                href={siteConfig.demoUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="servicenow-hero-cta group"
              >
                Book a demo
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
              </a>
            </div>

            <div className="servicenow-video-shell">
              <div className="servicenow-video-crop">
                <iframe
                  className="servicenow-video-iframe"
                  src="https://www.loom.com/embed/9c387abcd34946a89479e7635b5932b8"
                  title="Lab0 ServiceNow rollout demo"
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  allow="fullscreen; web-share"
                  allowFullScreen
                />
              </div>
            </div>
          </div>
        </section>

        <section className="relative px-6 lg:px-8 py-24 lg:py-32">
          <div className="absolute top-0 left-6 right-6 lg:left-8 lg:right-8 h-px bg-black/[0.06]" />
          <div className="mx-auto w-full max-w-7xl">
            <div className="grid gap-px bg-black/[0.06] border border-black/[0.06] md:grid-cols-3">
              {cards.map((card, index) => (
                <article key={card.title} className="bg-white p-8 lg:p-10">
                  <div className="font-mono text-xs text-[#1a1a1a]/15 mb-4">
                    {String(index + 1).padStart(2, "0")}
                  </div>
                  <h2 className="font-display text-xl lg:text-2xl font-semibold text-[#1a1a1a]/85 mb-3">
                    {card.title}
                  </h2>
                  <p className="text-sm text-[#1a1a1a]/45 leading-relaxed">
                    {card.description}
                  </p>
                </article>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
